/**
 * usePrefersReducedMotion — listens to the OS-level reduced-motion preference.
 *
 * Returns ``true`` when ``prefers-reduced-motion: reduce`` matches. Live-updates
 * if the user toggles the OS setting while the page is open. Safe to call in
 * SSR — falls back to ``false`` when ``window`` is undefined.
 */
import { useEffect, useState } from "react";

export function usePrefersReducedMotion(): boolean {
  const [reduced, setReduced] = useState<boolean>(false);

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
    setReduced(mq.matches);
    const onChange = (e: MediaQueryListEvent) => setReduced(e.matches);
    mq.addEventListener?.("change", onChange);
    return () => mq.removeEventListener?.("change", onChange);
  }, []);

  return reduced;
}
